import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import './styles/index.less';
var rootEl = document.getElementById('root');
var root = createRoot(rootEl);
root.render(_jsx(App, {}));
